// ============================================================================
// Section 3 — Tools that power cleanings (4 feature cards in a row)
// ============================================================================

import { Calendar, Smartphone, Package, Users, ArrowRight } from "lucide-react";

const CARDS = [
  {
    title: "Smart schedules",
    body: "Calendar sync generates a clean schedule automatically — or create tasks manually when needed.",
    icon: Calendar,
    iconBg: "bg-orange-100 text-orange-600",
  },
  {
    title: "Cleaner dashboard",
    body: "Mobile-first task list with checklist steps, timers, photo uploads, and issue reporting.",
    icon: Smartphone,
    iconBg: "bg-amber-100 text-amber-600",
  },
  {
    title: "Inventory tracking",
    body: "Track supplies during cleanings and flag low stock so restocks never slip.",
    icon: Package,
    iconBg: "bg-primary/15 text-primary",
  },
  {
    title: "Team delegation",
    body: "Managers can invite workers, assign tasks, and keep everything contained to the property.",
    icon: Users,
    iconBg: "bg-blue-100 text-blue-600",
  },
];

export default function ToolsSection() {
  return (
    <section id="product" className="border-t border-border/60 bg-background py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-6">
        {/* Header: heading left, paragraph right */}
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-12">
          <h2 className="text-3xl font-bold leading-tight tracking-tight text-foreground sm:text-4xl">
            Tools that power cleanings
          </h2>
          <p className="text-muted-foreground sm:text-lg">
            Stravo is built for real turnover workflows — scheduling, checklists, inventory, and delegation in one
            place.
          </p>
        </div>

        {/* 4 cards in a row */}
        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {CARDS.map((item) => {
            const Icon = item.icon;
            return (
              <article
                key={item.title}
                className="group flex flex-col rounded-3xl border border-border/80 bg-card p-6 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
              >
                <div
                  className={`mb-4 flex h-10 w-10 items-center justify-center rounded-xl ${item.iconBg}`}
                  aria-hidden
                >
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="text-lg font-semibold text-foreground">{item.title}</h3>
                <p className="mt-2 flex-1 text-sm text-muted-foreground">{item.body}</p>
                <div className="mt-4 flex justify-end">
                  <button
                    type="button"
                    className="flex h-9 w-9 items-center justify-center rounded-full border border-border bg-muted/50 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
                    aria-label={`Learn more about ${item.title}`}
                  >
                    <ArrowRight className="h-4 w-4" />
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
